define('models/merchants/businesshours_collection',['backbone',
], function (Backbone) {
    var BusinessHours = Backbone.Model.extend({

        url: function () {
            return pf.merchantsURL + "/" + this.MerchantGUID + "/Locations";
        },

        initialize: function (options) {
            options || (options = {});
            this.OpenTime = options.OT;
            this.CloseTime = options.CT;
            this.DayOfWeek = options.DOW;

        },
        parse: function (data) {
            var response = {};

            response.OpenTime = data.OT;
            response.CloseTime = data.CT;
            response.DayOfWeek = data.DOW;


            return response;
        },
        save: function (attributes, options) {
            options = options || {};
            attributes = attributes || {};;

            var data = {};
            data.OT = this.attributes.OpenTime;
            data.CT = this.attributes.CloseTime;
            data.DOW = this.attributes.DayOfWeek;
            

            this.attributes = data;

            return Backbone.Model.prototype.save.call(this, attributes, options);
        }
    });
    return Backbone.Collection.extend({
        url: function () {
            return null;
        },
        model: BusinessHours,
        initialize: function (options) {

            options || (options = {});
        }
    });
});

